/**
 * 検査分類
 */
export class Classification {
    /** 検査分類コード */
    code = ""
    /** 検査分類名 */
    name = ""
    /** 部門コード */
    departmentCode = ""
    /** 報告書 */
    reportNo = ""

    /**
     * コンストラクタ
     * @param init 
     */
    constructor(init?: Partial<Classification>) {
        Object.assign(this, init)
    }

    /**
     * 複製を作成する
     */
    clone() {
        return new Classification(JSON.parse(JSON.stringify(this)));
    }

}
